import type { SearchFilterItem } from '@/types/search';

const isNonEmptyString = (v: unknown): v is string =>
  typeof v === 'string' && v.trim().length > 0;

const filterVisibleFilterItems = (
  items?: SearchFilterItem[],
): SearchFilterItem[] | undefined =>
  items?.filter((item) => isNonEmptyString(item.label));

export default filterVisibleFilterItems;
